import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Modal, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { Large, Primary } from "../../stories/Button.stories";
import UserService from "../../services/user.service";
import Loading from "../../common/Loading";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import { customStyles, customStylesError } from "../../common/CustomStyles";
import imageX from "../../assets/images/x.svg";

const ReminderSetting = (props) => {
  let { uuid, userUUID } = useParams();
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  let userType = localStorage.getItem("userType");
  // const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [title, setTitle] = useState("Group Settings");
  const [subTitle, setSubTitle] = useState(
    "Manage your settings for the group that you are part of on Elderly Life."
  );
  const initialFormValues = {
    settings1: "",
    settings2: "",
    settings3: "",
    selectedSavings1: "",
    selectedSavings2: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [selectedSettings1, setSelectedSettings1] = useState();
  const [selectedSettings2, setSelectedSettings2] = useState();
  const [selectedSettings3, setSelectedSettings3] = useState();
  const [successToast, setSuccessToast] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [stopFn, setStopFn] = useState("");
  const [loader, setLoader] = useState(true);
  const [loadYes, setLoadYes] = useState("");

  const initialfilterOption = [
    { value: "3Months", label: "3 Months" },
    { value: "2Months", label: "2 Months" },
    { value: "1Month", label: "1 Month" },
    { value: "3Weeks", label: "3 Weeks" },
    { value: "2Weeks", label: "2 Weeks" },
    { value: "1Week", label: "1 Week" },
  ];
  const [filterOption1, setFilterOption1] = useState(initialfilterOption);
  const [filterOption2, setFilterOption2] = useState(initialfilterOption);
  const [filterOption3, setFilterOption3] = useState(initialfilterOption);

  const initialSavingOpt = [
    { value: "any_one", label: "Anyone" },
    // { value: "el_staff", label: "Only EL staff" },
    { value: "all_su", label: "Only your Support Users" },
    { value: "selected_su", label: "Selected Support Users" },
    { value: "no_one", label: "No one except me" },
  ];
  const [selectedSavings1, setSelectedSavings1] = useState({
    value: "any_one",
    label: "Anyone",
  });
  const [selectedSavings2, setSelectedSavings2] = useState({
    value: "any_one",
    label: "Anyone",
  });

  const [viewableUsers, setviewableUsers] = useState([]);
  const [fetchSU, setFetchSu] = useState([]);
  const [selectedAddModal, setSelectedAddModal] = useState(false);
  const [selectedViewModal, setSelectedViewModal] = useState(false);
  const [selectedCards, setSelectedCards] = useState([]);
  const [isChooseInviteDisabled, setIsChooseInviteDisabled] = useState(true);
  const [selectedAddUsers, setSelectedAddUsers] = useState([]);
  const [selectedViewUsers, setSelectedViewUsers] = useState([]);
  const [selectedAddUsersList, setSelectedAddUsersList] = useState([]);
  const [selectedViewUsersList, setSelectedViewUsersList] = useState([]);
  const [famID, setfamID] = useState();
  const [famUserId, setfamUserId] = useState();

  const handleChange = (e, action) => {
    if (action) {
      var targetData = {
        name: action.name,
        value: e.value,
      };
      let abc = { label: "select settings", value: "" };
      if (action.name === "settings1") {
        setSelectedSettings1(e);
        setSelectedSettings2(abc);
        setSelectedSettings3(abc);
        const { name, value } = targetData;
        setFormValues({
          ...formValues,
          settings1: e.value,
          settings2: "",
          settings3: "",
        });

        if (e.value === "3Months") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months" },
            { value: "1Month", label: "1 Month" },
            { value: "3Weeks", label: "3 Weeks" },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption2(newOption);
        } else if (e.value === "2Months") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month" },
            { value: "3Weeks", label: "3 Weeks" },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption2(newOption);
        } else if (e.value === "1Month") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks" },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption2(newOption);
        } else if (e.value === "3Weeks") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks", isdisabled: true },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption2(newOption);
        } else if (e.value === "2Weeks") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks", isdisabled: true },
            { value: "2Weeks", label: "2 Weeks", isdisabled: true },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption2(newOption);
        } else if (e.value === "1Week") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks", isdisabled: true },
            { value: "2Weeks", label: "2 Weeks", isdisabled: true },
            { value: "1Week", label: "1 Week", isdisabled: true },
          ];
          setFilterOption2(newOption);
        }
      } else if (action.name === "settings2") {
        setSelectedSettings2(e);
        setSelectedSettings3(abc);
        setFormValues({
          ...formValues,
          settings2: e.value,
          settings3: "",
        });
        if (e.value === "3Months") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months" },
            { value: "1Month", label: "1 Month" },
            { value: "3Weeks", label: "3 Weeks" },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption3(newOption);
        } else if (e.value === "2Months") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month" },
            { value: "3Weeks", label: "3 Weeks" },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption3(newOption);
        } else if (e.value === "1Month") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks" },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption3(newOption);
        } else if (e.value === "3Weeks") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks", isdisabled: true },
            { value: "2Weeks", label: "2 Weeks" },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption3(newOption);
        } else if (e.value === "2Weeks") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks", isdisabled: true },
            { value: "2Weeks", label: "2 Weeks", isdisabled: true },
            { value: "1Week", label: "1 Week" },
          ];
          setFilterOption3(newOption);
        } else if (e.value === "1Week") {
          const newOption = [
            { value: "3Months", label: "3 Months", isdisabled: true },
            { value: "2Months", label: "2 Months", isdisabled: true },
            { value: "1Month", label: "1 Month", isdisabled: true },
            { value: "3Weeks", label: "3 Weeks", isdisabled: true },
            { value: "2Weeks", label: "2 Weeks", isdisabled: true },
            { value: "1Week", label: "1 Week", isdisabled: true },
          ];
          setFilterOption3(newOption);
        }
      } else if (action.name === "settings3") {
        setSelectedSettings3(e);
        setFormValues({
          ...formValues,
          settings3: e.value,
        });
      } else if (action.name === "selectedSavings1") {
        if (e.value === "any_one") {
          setSelectedSavings2({ value: "any_one", label: "Anyone" });
        } else {
          if (e.value === "selected_su") {
            setSelectedAddModal(true);
            setSelectedCards(selectedAddUsers);
          }
          setSelectedSavings2({
            label: "select savings",
            value: "",
          });
        }
        setSelectedAddUsers([]);
        setSelectedSavings1(e);
        setFormValues({
          ...formValues,
          selectedSavings1: e.value,
        });
      } else if (action.name === "selectedSavings2") {
        if (e.value === "selected_su") {
          setSelectedViewModal(true);
          setSelectedCards(selectedViewUsers);
        }
        setSelectedViewUsers([]);
        setSelectedSavings2(e);
        setFormValues({
          ...formValues,
          selectedSavings2: e.value,
        });
      }
    }
  };

  useEffect(() => {
    if (userUUID) {
      UserService.userProfile(userUUID).then((response) => {
        getFamilyDetails(response.userData.id);
        let pUser = response.userData;
        // setParentUser(response.userData);
        setTitle(
          pUser.firstName + " " + pUser.lastName + "'s Reminder Settings"
        );
        setSubTitle(
          "Manage settings for the families that you are part of on Elderly Life for " +
            pUser.firstName +
            " " +
            pUser.lastName +
            " here"
        );
      });
    } else {
      getFamilyDetails(UserDetails.id);
    }
  }, []);

  // get family details
  const getFamilyDetails = (userId) => {
    if (stopFn === "") {
      if (loadYes === "") {
        UserService.getUserSingleFamilyDetails(uuid, userId).then(
          (response) => {
            // get all support user
            let payLoad1 = {
              fid: response.FamilyData.Family.id,
              fuid: response.FamilyData.id,
            };
            UserService.getSupData(payLoad1).then((resp) => {
              setFetchSu(resp.data);

              setfamID(response.FamilyData.Family.id);
              setfamUserId(response.FamilyData.id);
              // viewable users
              let payLoad = {
                FamilyId: response.FamilyData.Family.id,
                FamilyUserId: response.FamilyData.id,
              };
              UserService.savingsAuthUsers(payLoad).then((respo) => {
                setviewableUsers(respo.viewableData);

                const initialValues = {
                  settings1: response.FamilyData.settings1,
                  settings2: response.FamilyData.settings2,
                  settings3: response.FamilyData.settings3,
                  selectedSavings1: respo.viewableData[0].addPrevilege,
                  selectedSavings2: respo.viewableData[0].viewPrevilege,
                  user_family_id: response.FamilyData.id,
                };
                setFormValues(initialValues);

                setSelectedSettings1({
                  value: response.FamilyData.settings1,
                  label: addSpaceInStr(response.FamilyData.settings1),
                });
                setSelectedSettings2({
                  value: response.FamilyData.settings2,
                  label: addSpaceInStr(response.FamilyData.settings2),
                });
                setSelectedSettings3({
                  value: response.FamilyData.settings3,
                  label: addSpaceInStr(response.FamilyData.settings3),
                });
                setSelectedSavings1({
                  value: respo.viewableData[0].addPrevilege,
                  label:
                    respo.viewableData[0].addPrevilege === "any_one"
                      ? "Anyone"
                      : respo.viewableData[0].addPrevilege === "el_staff"
                      ? "Only EL staff"
                      : respo.viewableData[0].addPrevilege === "all_su"
                      ? "Only your Support Users"
                      : respo.viewableData[0].addPrevilege === "selected_su"
                      ? "Selected Support Users"
                      : "No one except me",
                });
                setSelectedSavings2({
                  value: respo.viewableData[0].viewPrevilege,
                  label:
                    respo.viewableData[0].viewPrevilege === "any_one"
                      ? "Anyone"
                      : respo.viewableData[0].viewPrevilege === "el_staff"
                      ? "Only EL staff"
                      : respo.viewableData[0].viewPrevilege === "all_su"
                      ? "Only your Support Users"
                      : respo.viewableData[0].viewPrevilege === "selected_su"
                      ? "Selected Support Users"
                      : "No one except me",
                });

                const updatedSelectedAddUsers =
                  respo.viewableData[0].addPrevilege !== "no_one" &&
                  respo.viewableData[0].addableUsers.map((id) => {
                    const user = resp.data.find(
                      (user) => user.supportuserid === id
                    );

                    return user ? user : [];
                  });
                setSelectedAddUsersList(updatedSelectedAddUsers);

                const updatedSelectedEditUsers =
                  respo.viewableData[0].viewPrevilege !== "no_one" &&
                  respo.viewableData[0].viewableUsers.map((id) => {
                    const user = resp.data.find(
                      (user) => user.supportuserid === id
                    );
                    return user ? user : [];
                  });
                setSelectedViewUsersList(updatedSelectedEditUsers);

                setSelectedAddUsers(respo.viewableData[0].addableUsers);
                setSelectedViewUsers(respo.viewableData[0].viewableUsers);
                //setFamilyDetails(response.FamilyData);

                //setting 1
                if (response.FamilyData.settings1 === "3Months") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months" },
                    { value: "1Month", label: "1 Month" },
                    { value: "3Weeks", label: "3 Weeks" },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption2(newOption);
                } else if (response.FamilyData.settings1 === "2Months") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month" },
                    { value: "3Weeks", label: "3 Weeks" },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption2(newOption);
                } else if (response.FamilyData.settings1 === "1Month") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks" },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption2(newOption);
                } else if (response.FamilyData.settings1 === "3Weeks") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks", isdisabled: true },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption2(newOption);
                } else if (response.FamilyData.settings1 === "2Weeks") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks", isdisabled: true },
                    { value: "2Weeks", label: "2 Weeks", isdisabled: true },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption2(newOption);
                } else if (response.FamilyData.settings1 === "1Week") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks", isdisabled: true },
                    { value: "2Weeks", label: "2 Weeks", isdisabled: true },
                    { value: "1Week", label: "1 Week", isdisabled: true },
                  ];
                  setFilterOption2(newOption);
                }

                //setting 2
                if (response.FamilyData.settings2 === "3Months") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months" },
                    { value: "1Month", label: "1 Month" },
                    { value: "3Weeks", label: "3 Weeks" },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption3(newOption);
                } else if (response.FamilyData.settings2 === "2Months") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month" },
                    { value: "3Weeks", label: "3 Weeks" },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption3(newOption);
                } else if (response.FamilyData.settings2 === "1Month") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks" },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption3(newOption);
                } else if (response.FamilyData.settings2 === "3Weeks") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks", isdisabled: true },
                    { value: "2Weeks", label: "2 Weeks" },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption3(newOption);
                } else if (response.FamilyData.settings2 === "2Weeks") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks", isdisabled: true },
                    { value: "2Weeks", label: "2 Weeks", isdisabled: true },
                    { value: "1Week", label: "1 Week" },
                  ];
                  setFilterOption3(newOption);
                } else if (response.FamilyData.settings2 === "1Week") {
                  const newOption = [
                    { value: "3Months", label: "3 Months", isdisabled: true },
                    { value: "2Months", label: "2 Months", isdisabled: true },
                    { value: "1Month", label: "1 Month", isdisabled: true },
                    { value: "3Weeks", label: "3 Weeks", isdisabled: true },
                    { value: "2Weeks", label: "2 Weeks", isdisabled: true },
                    { value: "1Week", label: "1 Week", isdisabled: true },
                  ];
                  setFilterOption3(newOption);
                }
                if (loadYes === "") {
                  setLoader(false);
                }
              });
            });
            //setting 3
          },
          (error) => {}
        );
      }
    }
  };

  console.log(selectedCards);

  const handleCheckboxChange = (id) => {
    setSelectedCards(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((cardId) => cardId !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
    if (selectedAddModal) {
      setSelectedAddUsers(
        (prevSelected) =>
          prevSelected.includes(id)
            ? prevSelected.filter((cardId) => cardId !== id) // Remove if already selected
            : [...prevSelected, id] // Add if not selected
      );
    } else {
      setSelectedViewUsers(
        (prevSelected) =>
          prevSelected.includes(id)
            ? prevSelected.filter((cardId) => cardId !== id) // Remove if already selected
            : [...prevSelected, id] // Add if not selected
      );
    }
  };

  const addData = () => {
    setSelectedAddModal(false);
    setSelectedViewModal(false);
    setSelectedCards([]);
    if (selectedAddModal) {
      const updatedSelectedAddUsers = selectedCards.map((id) => {
        const user = fetchSU.find((user) => user.supportuserid === id);
        return user ? user : [];
      });
      setSelectedAddUsersList(updatedSelectedAddUsers);
    } else {
      const updatedSelectedEditUsers = selectedCards.map((id) => {
        const user = fetchSU.find((user) => user.supportuserid === id);
        return user ? user : [];
      });
      setSelectedViewUsersList(updatedSelectedEditUsers);
    }
  };

  console.log(selectedAddUsersList);
  console.log(selectedViewUsersList);

  useEffect(() => {
    if (selectedCards.length > 0) {
      setIsChooseInviteDisabled(false);
    } else {
      setIsChooseInviteDisabled(true);
    }
  }, [selectedCards]);

  // handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };
  // validation
  const validate = (values) => {
    const errors = {};
    if (formValues.settings1 === "") {
      errors.msg = "Please enter the first setting";
      errors.settings1 = "Yes";
    }
    if (formValues.settings2 === "") {
      errors.msg = "Please enter the second setting";
      errors.settings2 = "Yes";
    }
    if (formValues.settings3 === "") {
      errors.msg = "Please enter the third setting";
      errors.settings3 = "Yes";
    }
    if (formValues.selectedSavings1 === "") {
      errors.msg = "Please select the add account option";
      errors.selectedSavings1 = "Yes";
    }
    if (formValues.selectedSavings2 === "") {
      errors.msg = "Please select the view account";
      errors.selectedSavings2 = "Yes";
    }
    return errors;
  };
  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      let data = {
        settings1: formValues.settings1,
        settings2: formValues.settings2,
        settings3: formValues.settings3,
      };
      // api call
      UserService.updateReminderSetting(
        uuid,
        formValues.user_family_id,
        data
      ).then(
        (response) => {
          if (response.status === 400) {
            window.scrollTo(0, 0);
            setSuccessToast(false);
            setShowToast(true);
            setToastMessage(response.data.message);
          } else {
            let payload = {
              FamilyId: famID,
              FamilyUserId: famUserId,
              addPrevilege: formValues.selectedSavings1,
              viewPrevilege: formValues.selectedSavings2,
              addableUsers:
                selectedSavings1.value === "no_one"
                  ? [famUserId]
                  : selectedAddUsers,
              viewableUsers:
                selectedSavings2.value === "no_one"
                  ? [famUserId]
                  : selectedViewUsers,
            };
            UserService.savingsAuthCreate(payload).then(
              (respo) => {
                if (response.status === 400) {
                  window.scrollTo(0, 0);
                  setSuccessToast(false);
                  setShowToast(true);
                  setToastMessage(response.data.message);
                } else {
                  window.scrollTo(0, 0);
                  setUpdateLoading(false);
                  setSuccessToast(true);
                  setShowToast(true);
                  setToastMessage("Group settings updated successfully");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              },
              (error) => {}
            );
          }
        },
        (error) => {}
      );
    }
  }, [formErrors]);

  const addSpaceInStr = (str) => {
    var newStr = "";
    if (str !== "Never") {
      var position = 1;
      newStr = [str.slice(0, position), str.slice(position)].join(" ");
    } else {
      newStr = str;
    }
    return newStr;
  };

  return (
    <div className="page-content reminder-pg tab-btn">
      <Container fluid>
        {/* {details} */}
        <ToastBlockContainer
          successToast={successToast}
          showToast={showToast}
          setShowToast={setShowToast}
          toastMessage={toastMessage}
        />
        <Row className="justify-content-center gy-0 mb-6rem">
          <Col xl="21" xxl="21">
            <>
              <h1>{title}</h1>
              <p className="sub-title">{subTitle}</p>
            </>
            <Row className="">
              {loader ? (
                <div
                  style={{
                    minHeight: "calc(100vh - 20rem)",
                  }}
                  className="d-flex flex-column"
                >
                  <Loading />
                </div>
              ) : (
                <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
                  <Form onSubmit={handleSubmit}>
                    <section>
                      {(userType === "AO + AU" ||
                        userType === "AO + AU + SU" ||
                        userType === "AO" ||
                        userType === "AO + SU") && (
                        <div>
                          <h2 className="mb-1 mb-md-2">Reminders </h2>
                          <Row className="my-3">
                            <p className="sub-title mb-2">
                              The following reminder settings are applicable to
                              all the Elderly Life modules except To Do's.{" "}
                            </p>
                            <p className="sub-title">
                              {" "}
                              For To Do's by default you will be reminded via
                              notification before a Week, before a Day & on the
                              day of the To Do's.
                            </p>
                            <hr className=""></hr>
                          </Row>
                          <Row className="reminder-select mb-3 d-flex flex-column flex-md-row align-items-center gap-3">
                            <Col className="reminder-box p-4 border rounded bg-white ">
                              <p className="mb-2 fw-semibold">1st Reminder</p>
                              <p className="">
                                Reminder will be sent based on the selection
                                below
                              </p>

                              <Select
                                styles={
                                  formErrors.settings1
                                    ? customStylesError
                                    : customStyles
                                }
                                options={filterOption1}
                                defaultValue={{
                                  label: "select settings",
                                  value: "",
                                }}
                                value={selectedSettings1}
                                onChange={handleChange}
                                name="settings1"
                                isOptionDisabled={(option) => option.isdisabled}
                              />
                            </Col>
                            <Col className="reminder-box p-4 border rounded bg-white ">
                              <p className="mb-2 fw-semibold">2nd Reminder</p>
                              <p className="">
                                Reminder will be sent based on the selection
                                below
                              </p>
                              <Select
                                styles={
                                  formErrors.settings2
                                    ? customStylesError
                                    : customStyles
                                }
                                options={filterOption2}
                                defaultValue={{
                                  label: "select settings",
                                  value: "",
                                }}
                                value={selectedSettings2}
                                onChange={handleChange}
                                name="settings2"
                                isOptionDisabled={(option) => option.isdisabled}
                              />
                            </Col>
                            <Col className="reminder-box p-4 border rounded bg-white ">
                              <p className="mb-2 fw-semibold">3rd Reminder</p>
                              <p className="">
                                Reminder will be sent based on the selection
                                below
                              </p>
                              <Select
                                styles={
                                  formErrors.settings3
                                    ? customStylesError
                                    : customStyles
                                }
                                options={filterOption3}
                                defaultValue={{
                                  label: "select settings",
                                  value: "",
                                }}
                                value={selectedSettings3}
                                onChange={handleChange}
                                name="settings3"
                                isOptionDisabled={(option) => option.isdisabled}
                              />
                            </Col>
                          </Row>
                          <hr className="mt-5 mb-3" />
                        </div>
                      )}

                      {(userType === "AO + AU + SU" ||
                        userType === "AO + AU" ||
                        userType === "AU + SU" ||
                        userType === "AU") && (
                        <div>
                          <h2 className="mb-1 mb-md-2">Life Accounts </h2>
                          <Row className="my-3">
                            <p className="sub-title mb-2">
                              The following settings ensure access rights to the
                              Accounts module to users other than yourself.
                            </p>
                            <hr className=""></hr>
                          </Row>
                          <Row className="reminder-select mb-3 d-flex flex-column flex-md-row align-items-center gap-3">
                            <Col className="reminder-box p-4 border rounded bg-white ">
                              <p className="mb-2 fw-semibold">Add Savings</p>
                              <p className="">
                                Select the users who can add accounts for you
                              </p>

                              {selectedAddUsersList &&
                              selectedAddUsersList.length !== 0 ? (
                                <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                                  <div className="text-truncate d-flex align-items-center gap-3">
                                    {selectedAddUsersList &&
                                      selectedAddUsersList.map((val, index) => (
                                        <>
                                          <div key={index}>
                                            {val.supportusername}
                                          </div>
                                        </>
                                      ))}
                                  </div>
                                  <button
                                    className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                                    type="button"
                                    onClick={() => {
                                      setSelectedAddUsersList([]);
                                      setSelectedSavings1({
                                        value: "any_one",
                                        label: "Anyone",
                                      });
                                      setFormValues((prevValues) => ({
                                        ...prevValues,
                                        selectedSavings1: "",
                                      }));
                                    }}
                                  >
                                    <img
                                      src={imageX}
                                      alt=""
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </button>
                                </div>
                              ) : (
                                <Select
                                  styles={
                                    formErrors.selectedSavings1
                                      ? customStylesError
                                      : customStyles
                                  }
                                  options={initialSavingOpt}
                                  defaultValue={{
                                    label: "select accounts",
                                    value: "",
                                  }}
                                  value={selectedSavings1}
                                  onChange={handleChange}
                                  name="selectedSavings1"
                                  // isOptionDisabled={(option) => option.isdisabled}
                                />
                              )}
                            </Col>
                            <Col className="reminder-box p-4 border rounded bg-white ">
                              <p className="mb-2 fw-semibold">View Accounts</p>
                              <p className="">
                                Select the users who can view your accounts
                              </p>

                              {selectedViewUsersList &&
                              selectedViewUsersList.length !== 0 ? (
                                <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                                  <div className="text-truncate d-flex align-items-center gap-3">
                                    {selectedViewUsersList.map((val, index) => (
                                      <>
                                        <div key={index}>
                                          {val.supportusername}
                                        </div>
                                      </>
                                    ))}
                                  </div>
                                  <button
                                    className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                                    type="button"
                                    onClick={() => {
                                      setSelectedViewUsersList([]);
                                      setSelectedSavings2({
                                        value: "any_one",
                                        label: "Anyone",
                                      });
                                      setFormValues((prevValues) => ({
                                        ...prevValues,
                                        selectedSavings2: "",
                                      }));
                                    }}
                                  >
                                    <img
                                      src={imageX}
                                      alt=""
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </button>
                                </div>
                              ) : (
                                <Select
                                  styles={
                                    formErrors.selectedSavings2
                                      ? customStylesError
                                      : customStyles
                                  }
                                  options={
                                    selectedSavings1 &&
                                    selectedSavings1.value === "any_one"
                                      ? [{ value: "any_one", label: "Anyone" }]
                                      : initialSavingOpt
                                  }
                                  defaultValue={{
                                    label: "select accounts",
                                    value: "",
                                  }}
                                  value={selectedSavings2}
                                  onChange={handleChange}
                                  name="selectedSavings2"
                                  // isOptionDisabled={(option) => option.isdisabled}
                                />
                              )}
                            </Col>
                          </Row>
                          <hr className="mt-5 mb-3" />
                        </div>
                      )}
                      <div className="d-flex align-items-center justify-content-end mt-7">
                        <Large
                          children="Save Updates"
                          size="mediumbtn"
                          variant="primary"
                          type="submit"
                          className="btn btn-primary"
                          isLoading={updateLoading ? "true" : "false"}
                          isDisabled={updateLoading ? "true" : "false"}
                        />
                      </div>
                    </section>
                  </Form>
                </section>
              )}
            </Row>
          </Col>
        </Row>
      </Container>

      {/* selected SU modal  */}
      <Modal
        show={selectedAddModal ? selectedAddModal : selectedViewModal}
        onHide={() => {
          setSelectedAddModal(false);
          setSelectedViewModal(false);
          setSelectedCards([]);
        }}
        className=""
      >
        <Modal.Header closeButton>
          <Modal.Title className="mx-1">
            <h3 className="mb-0">Your Support Users</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-5">
            <Form.Label className="mb-3">
              {selectedAddModal
                ? "Select one or more Support Users from the below to Add accounts on your behalf"
                : "Select one or more Support Users from the below to View accounts on your behalf"}
            </Form.Label>

            {fetchSU && fetchSU.length !== 0 ? (
              fetchSU.map((suList, index) => (
                <Card
                  key={index}
                  className={`story-card add-support-card basic-cards mb-3`}
                >
                  <Card.Body className="p-3">
                    <label className="d-flex gap-3">
                      <span className="float-left">
                        <input
                          className="form-check-input"
                          style={{ cursor: "pointer" }}
                          type="checkbox"
                          id={`checkbox-${suList.supportuserid}`}
                          checked={selectedCards.includes(suList.supportuserid)}
                          onChange={() =>
                            handleCheckboxChange(suList.supportuserid)
                          }
                        />
                      </span>
                      <span className="panel panel-default card-input">
                        {/* <p className="panel-heading card-right">{last4digit}</p> */}
                        <p className="panel-heading card-right my-0">
                          <strong>{suList.supportusername}</strong>
                        </p>
                      </span>
                    </label>
                  </Card.Body>
                </Card>
              ))
            ) : (
              <div className="text-center mt-4 mb-4">
                {" "}
                <p>No data found</p>{" "}
              </div>
            )}
            <div className="text-center mt-4 mb-4">
              <Primary
                children="+ Add"
                variant="primary"
                size="mediumbtn"
                type="button"
                className="btn btn-primary"
                disabled={isChooseInviteDisabled ? "disabled" : ""}
                onClick={() => addData()}
                // isLoading={chooseSuFormLoading ? "true" : "false"}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default ReminderSetting;
